<article>
    <section class="top-section pl-4 pr-4 d-flex flex-row align-items-end">
        <div class="col-12 col-sm-6 align-self-start">
            <h1 class="mb-4">500</h1>
            <div class="description">
                <div class="mb-4">
                    Something went wrong when trying to display this page. Sorry for the
                    inconvenience. We are working to fix the issue.
                </div>
                <div>
                    In the meantime, explore new resources on our
                    <a [routerLink]="[isStudent ? '/student' : '/']" title="Homepage">home page</a>,
                    or browse by subject below. You could also try searching for something similar.
                </div>
                <div *ngIf="errorMessage" class="debug-error-message mt-2">
                    ERROR: {{ errorMessage }}
                </div>
            </div>
        </div>
        <div>
            <img class="error-img d-none d-sm-block" [src]="image" />
        </div>
    </section>
    <section class="bottom-section w-100 pl-4 pr-4 pb-3">
        <app-subject-list [subjects]="subjects"></app-subject-list>
    </section>
</article>
